import { renderContentProps } from "./types";
import { NormalMessage } from "./normal-message";
import { MessageAttachments } from "../../components/message-attachments";

/**
 * PlatformMessage - Shared component for IG and FB messages.
 * Both platforms render identically: attachments followed by a normal message.
 *
 * Previously duplicated in: ig-message.tsx, fb-message.tsx
 */
export const PlatformMessage = (props: renderContentProps): JSX.Element => {
  return (
    <>
      <MessageAttachments {...props} />
      <NormalMessage {...props} />
    </>
  );
};
